import React, { useCallback, useMemo, useEffect } from 'react'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, addActionOnRow } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { EventZoneForm } from '../event-zone-form/EventZoneForm'

export const EventZoneView = ({ eventId }) => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/event-zone/event/' + eventId
  })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_event_zone

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <EventZoneForm eventId={eventId} rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/event-zone/delete',
            data: {
              p_id_event_zone: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={{
        icon_action: 'fa fa-plus',
        color_action: 'primary',
      }}
      showUpdate={{
        icon_action: 'fas fa-pencil-alt',
        color_action: 'info',
      }}
      showDelete={{
        icon_action: 'far fa-trash-alt',
        color_action: 'danger',
      }}
    />
  }, [setReload, eventId])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        { name: 'name_event_zone', text: 'Nombre', align: 'center' },
        { name: 'name_type_event_zone', text: 'Tipo Zona', align: 'center' },
        { name: 'price_event_zone', text: 'Precio', align: 'center' },
        { name: 'capacity_event_zone', text: 'Capacidad', align: 'center' },
        { name: 'qty_event_zone', text: 'Cant. Personas', align: 'center' },
        { name: 'enabled_event_zone', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_event_zone }) },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-12">
      {rowItem({
        type: 'create'
      })}
      {dtRows}
    </div>
  </div>
}